import { Component, Input, OnInit } from '@angular/core';
import { ArticleType, ArticleTypeCalculationRuleAttribute } from '../../article-type.model';

@Component({
  selector: 'app-article-type-calculation-rule-list',
  templateUrl: './article-type-calculation-rule-list.component.html',
  styleUrls: ['./article-type-calculation-rule-list.component.scss']
})
export class ArticleTypeCalculationRuleListComponent implements OnInit {

  @Input() articleType: ArticleType;

  @Input() calculationRules: Array<ArticleTypeCalculationRuleAttribute>;

  @Input() editCalculationRuleFunction: (args: any) => any;

  @Input() removeCalculationRuleFunction: (args: any) => any;

  constructor(
  ) { }

  ngOnInit(): void {
  }

  resolveArticleAttributeName(attributeId: number) {
    let attribute = this.articleType?.findArticleTypeAttributeById(attributeId);
    return attribute != null ? attribute.name : null;
  }

  getNonDeletedCalculationRules(): Array<ArticleTypeCalculationRuleAttribute> {
    return this.calculationRules.filter(r => !r.deleted);
  }

  editCalculationRule(value : ArticleTypeCalculationRuleAttribute) {
    this.editCalculationRuleFunction(value);
  }

  removeCalculationRule(value : ArticleTypeCalculationRuleAttribute) {
    this.removeCalculationRuleFunction(value);
  }

}
